import { ClampexType } from "../../types/types";
import { ProductActionTypes, ProductInputData, ProductInputDataRequiredFields } from './productTypes';
import {  Dispatch } from "redux";
import axios from 'axios';
import * as Settings from '../../settings';
import { ApplicationState } from "../state";

export type UpdateProductAction = {
    type: ProductActionTypes,
    payload?: any
    error?: string
}

export function updateProduct(product: ClampexType) : UpdateProductAction {
    return {
        type: ProductActionTypes.UPDATE_PRODUCT,
        payload: product
    }
}

export function fetchProductCValues(product: ClampexType) : any {
    return async (dispatch: Dispatch) => {
        try{
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_CVALUES_REQUEST})
            const response = await axios(
                {
                    method: 'GET',
                    url: Settings.getAPIURL() + '/api/' + product + "/cvalues",
                    headers: {'Content-Type': 'application/json'}
                })
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_CVALUES_SUCCESS, payload: response.data})
        } catch (err) {
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_CVALUES_ERROR, payload: err})
            console.error("ERROR::",err);
        }
    }
}



export function fetchMetadata(product: ClampexType) : any {
    return async (dispatch: Dispatch) => {
        try{
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_METADATA_REQUEST})
            const response = await axios(
                {
                    method: 'GET',
                    url: Settings.getAPIURL() + '/api/' + product + "/meta",
                    headers: {'Content-Type': 'application/json'}
                })
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_METADATA_SUCCESS, payload: response.data})
        } catch (err) {
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_METADATA_ERROR, payload: err})
            console.error("ERROR::",err);
        }
    }
}


export function fetchProductSizes(product: ClampexType) : any {
    return async (dispatch: Dispatch) => {
        try{
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_SIZES_REQUEST})
            const response = await axios(
                {
                    method: 'GET',
                    url: Settings.getAPIURL() + '/api/' + product + "/sizes",
                    headers: {'Content-Type': 'application/json'}
                })
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_SIZES_SUCCESS, payload: response.data})
        } catch (err) {
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_SIZES_ERROR, payload: err})
            console.error("ERROR::",err);
        }
    }
}


export function fetchMaterials() : any {
    return async (dispatch: Dispatch) => {
        try{
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_SIZES_REQUEST})
            const response = await axios(
                {
                    method: 'GET',
                    url: Settings.getAPIURL() + '/api/material',
                    headers: {'Content-Type': 'application/json'}
                })
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_MATERIAL_REQUEST, payload: response.data})
        } catch (err) {
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_MATERIAL_ERROR, payload: err})
            console.error("ERROR::",err);
        }
    }
}




export function updateInputData(productInputData: ProductInputData) {   
    return {
        type: ProductActionTypes.UPDATE_INPUT_DATA,
        payload: {...productInputData}
    }
}

export function updateInputDataRequiredFields(productInputDataRequiredFields: ProductInputDataRequiredFields) { 
    return {
        type: ProductActionTypes.UPDATE_INPUT_DATA_REQUIRED_FIELDS,
        payload: {...productInputDataRequiredFields}
    }
}


export function fetchProductAttributes(product: ClampexType, shaftDiameter_d: number, hubInnerDiameter_d: number) : any {
    return async (dispatch: Dispatch, getState: () => ApplicationState) => {
        try{
            dispatch({type: ProductActionTypes.FETCH_PRODUCT_ATTRIBUTES_REQUEST})
 
            const response = await axios(
                {
                    method: 'POST',
                    url: Settings.getAPIURL() + '/api/' + product + "/attributes",
                    headers: {'Content-Type': 'application/json'},
                    data: {
                        shaftDiameter_d: shaftDiameter_d,
                        hubInnerDiameter_D: hubInnerDiameter_d
                    }
                })

                if(response.status === 204) {
                    console.log("No record");
                } else {
                    dispatch({type: ProductActionTypes.FETCH_PRODUCT_ATTRIBUTES_SUCCESS, payload: response.data});
                    
                    if(product === ClampexType.KTR150) {
                        if(getState().product.productInputData.screwPreloadForce === null || getState().product.productInputData.screwPreloadForce === undefined)
                            dispatch(updateInputData({screwPreloadForce: response.data.clampingForce_PA}));
                    } else {
                        if(getState().product.productInputData.screwBoltingTorque_Ts === null || getState().product.productInputData.screwBoltingTorque_Ts === undefined)
                            dispatch(updateInputData({screwBoltingTorque_Ts: response.data.screwBoltingTorque_Ts}));
                    }
                    
                }
        } catch (err) {
                dispatch({type: ProductActionTypes.FETCH_PRODUCT_ATTRIBUTES_ERROR, payload: err})
                console.error("ERROR::",err);
        }
    }
}


export function calculateClampex(product: ClampexType, productInputData: ProductInputData) : any {
    return async (dispatch: Dispatch) => {
        try{
            dispatch({type: ProductActionTypes.PRODUCT_CALCULATION_REQUEST})
            const response = await axios(
                {
                    method: 'POST',
                    url: Settings.getAPIURL() + '/api/' + product + "/calc",
                    headers: {'Content-Type': 'application/json'},
                    data: productInputData
                })

                    dispatch({type: ProductActionTypes.PRODUCT_CALCULATION_SUCCESS, payload: response.data})
                
        } catch (err) {
                dispatch({type: ProductActionTypes.PRODUCT_CALCULATION_ERROR, payload: err})
                console.error("ERROR::", err.response.data);
        }
    }
}

function openWindow( response:any, materialnumber: any ) {
    
   /* var file = new Blob([(response)], {type: 'application/pdf'});
    console.log(response);
                //var file = data['response'];
                var fileURL = URL.createObjectURL(file);
    
    //window.open(fileURL);
    console.log("URL", fileURL);

    var link = window.document.createElement('a');
    link.href = "www.google.de";
    link.target = "_blank";
    document.body.appendChild(link);
    //open url in new window 
    link.click();
    //remove link element from body
    document.body.removeChild(link);
    */

   const data = window.URL.createObjectURL(new Blob([(response)], {type: 'application/pdf'}));
   var link = document.createElement('a');
   link.href = data;
   link.download="KTR_clampex_datasheet_" + materialnumber + ".pdf";
   link.click();
   setTimeout(function(){
     // For Firefox it is necessary to delay revoking the ObjectURL
     window.URL.revokeObjectURL(data);
   }, 100);

    return { type: ProductActionTypes.PRODUCT_BROWSER_OPENED };
}


export function getPDFFile() : any {
    return async (dispatch: Dispatch, state: any) => {
        try{
            
            const appState : ApplicationState = state();
            
            dispatch({type: ProductActionTypes.PRODUCT_OPEN_DATASHEET})
            const response = await axios(
                {
                    
                    method: 'POST',
                    url: Settings.getAPIURL() + '/api/' + appState.product.currentProduct.type + "/download/pdf/" + appState.language.currentLanguage.langcode,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    responseType: 'blob',
                    data: appState.product.productInputData
                })
                
                dispatch(openWindow(response.data, appState.product.currentProduct.productData?.matNr));
                
        } catch (err) {
                dispatch({type: ProductActionTypes.PRODUCT_OPEN_DATASHEET_ERROR})
                console.error("ERROR::", err);
        }
    }
}